import { config } from '@/config/env'

const API = config.apiUrl

/** The app bearer, or '' when signed out. */
function token(): string {
  try {
    const raw =
      localStorage.getItem('inmeet_auth_session') || sessionStorage.getItem('inmeet_auth_session')
    if (!raw) return ''
    const parsed = JSON.parse(raw) as { session?: { accessToken?: string; expiresAt?: number } }
    const session = parsed?.session
    if (session?.expiresAt && session.expiresAt <= Date.now()) return ''
    return session?.accessToken || ''
  } catch {
    return ''
  }
}

/**
 * When this account last dismissed the tour, or null.
 *
 * Failures resolve to null rather than throwing: not knowing means falling back
 * to the local flag, which is the old behaviour, instead of blocking the app on
 * a profile read.
 */
export async function fetchTourSeenAt(): Promise<string | null> {
  const bearer = token()
  if (!bearer) return null
  try {
    const res = await fetch(`${API}/api/v1/users/me`, {
      credentials: 'include',
      headers: { Authorization: `Bearer ${bearer}` },
    })
    if (!res.ok) return null
    const body = await res.json()
    return body?.user?.tourSeenAt ?? null
  } catch {
    return null
  }
}

/** Record the dismissal on the account. Best effort — see markTourSeen. */
export async function markTourSeenOnServer(): Promise<void> {
  const bearer = token()
  if (!bearer) return
  try {
    await fetch(`${API}/api/v1/users/me`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${bearer}` },
      body: JSON.stringify({ tourSeen: true }),
    })
  } catch {
    /* one extra showing is the cost of failure, not a broken dismissal */
  }
}
